"use strict";

angular.module("portal.login").controller("ForgotUsername", [
    "$q",
    "$scope",
    "$state",
    "$rootScope",
    "Users",
    "Enterprise",
    "EnterpriseLoginCriteria",
    function (
        $q,
        $scope,
        $state,
        $rootScope,
        Users,
        Enterprise,
        EnterpriseLoginCriteria
    ) {
        $scope.loading = true;
        $scope.looking_up = false;
        $scope.newEmail = false;
        $scope.changeEmail = false;
        $scope.hasPublicIdentityProviders = false;
        $scope.disablePasswordLogin = false;
        $scope.displayForm = false;
        $scope.success = false;
        $scope.promises = [];
        $scope.widgetId = null;
        $scope.parameters = {
            enterpriseID: $rootScope.enterpriseID
        };
        $scope.failedMessages = [];
        $scope.login_criteria = {};
        $scope.lookup_object = { enterprise_id: $rootScope.enterpriseID };
        $scope.email_object = { enterprise_id: $rootScope.enterpriseID };

        // Make sure we have the enterprise details
        if ($rootScope.enterprise != null) {
            $scope.enterprise = $rootScope.enterprise;
        } else {
            Enterprise.getLess({ enterpriseID: $rootScope.enterpriseID, isPortal: true }).then(
                function (result) {
                    $scope.enterprise = result;
                }
            );
        }

        //recaptcha vars
        $scope.recaptchaMessage = ($scope.enterprise.recaptcha_site_key_v3 == null && $scope.enterprise.recaptcha_enabled) ? "There was an issue loading recaptcha, please try again or contact system administrator." : ""; //message to display

        var promises = [];

        // Get the input fields
        promises.push(EnterpriseLoginCriteria.get($scope.parameters).then(function (results) {
            if (results != null) {
                $scope.login_criteria = results;
            }
        }));

        //Checking if login via password is disabled
        promises.push(EnterpriseLoginCriteria.getEnterpriseDisablePasswordLogin().then(function (disable) {
            $scope.disablePasswordLogin = disable;
        }));

        //Checking if there are any identity providers set up for public portal
        promises.push(Enterprise.listPublicEnterpriseIdentityProvider().then(function (idpList) {
            $scope.hasPublicIdentityProviders = idpList && idpList.length > 0;
        }));

        $q.all(promises).then(function () {
            $scope.loading = false;
        }).catch(function (response) {
            // handle error
        });  

        $scope.setDisplayForm = function () {
            $scope.displayForm = true;
        }

        $scope.lookup = function () {
            $scope.failedMessages = [];
            $scope.looking_up = true;
            Users.lookupUsername($scope.lookup_object).then(function (result) {
                if (result != null) {
                    $scope.success = result.success;
                    if (result.messages != null) {
                        $scope.failedMessages = result.messages;
                    }
                    if (result.success) {
                        $scope.email_object.user_id = result.userid;
                        $scope.success = true;
                        if (result.no_email) {
                            $scope.newEmail = true;
                        } else if (result.change_email) {
                            var email = result.existing_email;
                            var emailDomain = email.split("@")[1];
                            $scope.maskedEmail =
                                email.substr(0, 2) + "*******@" + emailDomain;
                            $scope.changeEmail = true;
                        } else {
                            $state.go("portal.menus.login", {
                                messages: result.messages,
                                keepMessages: true
                            });
                        }
                    } else {
                        $state.go("portal.menus.login", {
                            messages: result.messages,
                            keepMessages: true
                        });
                    }
                }
                $scope.looking_up = false;
            });
        };

        $scope.recaptchaSubmit = function () {
            $scope.looking_up = true; //if there is a loading type var for display
            if ($scope.enterprise.recaptcha_enabled) {
                if ($scope.enterprise.recaptcha_site_key_v3 != null) {
                    grecaptcha.ready(function () {
                        try {
                            grecaptcha.execute($scope.enterprise.recaptcha_site_key_v3, { action: 'publicForgotUsername' }).then(function (token) { //execute returns a token
                                return Enterprise.getRecaptchaResponse("publicForgotUsername", token) // send action, token, score to pass over to server for validation, returns a response object
                            }).then(function (response) { // take the response and update variables
                                if (response.success == false) {
                                    $scope.recaptchaMessage = 'Recaptcha Error: ' + response.error;
                                    $scope.looking_up = false; //if there is a loading type var for display
                                } else {
                                    $scope.recaptchaMessage = "";
                                };
                            }).then(function () {
                                if ($scope.recaptchaMessage == "") {
                                    $scope.lookup(); //put function here if passed to continue normal "submit" is recaptcha passed
                                } else {
                                    $scope.$apply(); //update dom so error message displays if recaptcha failed
                                };
                            })
                        } catch (error) {
                            $scope.recaptchaMessage = "There was an issue loading recaptcha, please try again or contact system administrator.";
                            $scope.looking_up = false; //if there is a loading type var for display
                        }
                    });
                } else {
                    return;
                }
            } else {
                $scope.lookup(); //put function here to continue normal "submit" if recaptcha is turned off
            };
        };

        $scope.saveEmail = function () {
            if (
                $scope.email_object.new_email == null ||
                $scope.email_object.new_email == ""
            ) {
                $scope.failedMessages = ["Please enter an email address"];
            } else {
                $scope.loading = true;
                Users.saveEmail($scope.email_object).then(function (result) {
                    if (result != null) {
                        if (result) {
                            $scope.newEmail = false;
                            $scope.changeEmail = false;
                            $scope.failedMessages = [];
                            var emailDomain = $scope.email_object.new_email.split(
                                "@"
                            )[1];
                            $scope.maskedEmail =
                                $scope.email_object.new_email.substr(0, 2) +
                                "*******@" +
                                emailDomain;
                        } else {
                            $scope.failedMessages = [
                                "That email is already in use by an existing user account!"
                            ];
                        }
                    }
                    $scope.loading = false;
                });
            }
        };

        $scope.cancel = function () {
            $scope.loading = true;
            $state.go("portal.menus.login", {});
        };
    }
]);
